import { sva } from '@agapi/ui/panda/css';

export const locationDialogStyles = sva({
  slots: ['backdrop', 'dialogContent', 'positioner', 'container', 'logo', 'title', 'description', 'languageSelector', 'secondaryLabel', 'languageButtonContainer', 'languageButton', 'countrySelector', 'countrySelectorHeader', 'shopButton', 'closeButton'],
  base: {
    backdrop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(4px)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem'
    },

    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'surface.primary.subdued.background',
      borderRadius: 'surface.md',
      boxShadow: 'xl',
      maxWidth: '500px',
      width: '100%',
      maxHeight: '90vh',
      overflow: 'auto',
      position: 'relative'
    },

    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      p: '6',
      maxWidth: '400px',
      width: '100%'
    },

    logo: {
      marginBottom: '5'
    },

    title: {
      fontSize: '2xl',
      fontWeight: 'semibold',
      color: 'gray.900',
      marginBottom: '1rem'
    },

    description: {
      fontSize: 'md',
      color: 'gray.600',
      marginBottom: '5'
    },

    languageSelector: {
      width: '100%',
      marginBottom: '1.5rem',
      textAlign: 'left'
    },

    secondaryLabel: {
      marginBottom: '4',
      fontFamily: 'body',
      fontSize: 'lg',
      fontWeight: 'semibold',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '2'
    },

    languageButtonContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '2',
      justifyContent: 'center'
    },

    languageButton: {
      minWidth: 110,
      backgroundColor: 'white'
    },

    countrySelector: {
      width: '100%',
      marginBottom: '2rem',
      backgroundColor: 'default',
      textAlign: 'left'
    },

    shopButton: {
      width: '100%'
    },

    positioner: {
      zIndex: '2147483647!',
    },
  }
});